import { useState } from "react";
import type { FeedbackRequest, ModuleId } from "@quizshow/protocol";
import { submitFeedback } from "../api";
import { translate } from "../i18n";

export function FeedbackButton({
  audience,
  roomId,
  mode,
}: {
  audience: "host" | "participant";
  roomId?: string;
  mode: ModuleId;
}) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [category, setCategory] = useState<FeedbackRequest["category"]>("improvement");
  const [status, setStatus] = useState<string>();

  const send = async () => {
    setStatus("Wird gesendet...");
    try {
      const result = await submitFeedback({ audience, category, title, message, mode, roomId });
      setStatus(
        result.configured
          ? translate("feedbackThanks")
          : "Lokal angenommen. Feedback-Endpunkt ist noch nicht konfiguriert.",
      );
      setTitle("");
      setMessage("");
    } catch (error) {
      setStatus(error instanceof Error ? error.message : "Feedback konnte nicht gesendet werden.");
    }
  };

  return (
    <div className="feedback">
      <button className="button button--ghost button--small" onClick={() => setOpen((value) => !value)}>
        Feedback/Idee zu Quizshow Studio
      </button>
      {open ? (
        <div className="feedback__panel card">
          <strong>Feedback/Idee zu Quizshow Studio</strong>
          <select value={category} onChange={(event) => setCategory(event.target.value as typeof category)}>
            <option value="bug">Fehler melden</option>
            <option value="improvement">Verbesserung</option>
            {audience === "host" ? <option value="joker-idea">Joker-Idee</option> : null}
            {audience === "host" ? <option value="mode-idea">Spielmodus-Idee</option> : null}
          </select>
          <input value={title} onChange={(event) => setTitle(event.target.value)} placeholder="Kurzer Titel" />
          <textarea
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="Was möchtest du uns sagen?"
          />
          <button
            className="button button--accent"
            disabled={title.trim().length < 3 || message.trim().length < 5}
            onClick={() => void send()}
          >
            {translate("feedbackSend")}
          </button>
          {status ? <span className="muted">{status}</span> : null}
        </div>
      ) : null}
    </div>
  );
}
